/** Intenta recuperar tildes/Ñ rotas (mojibake / �) en texto de clientes. */

const CITY_FFFD_FIXES = [
  [/ALCAL\uFFFD/gi, 'ALCALÁ'],
  [/ACAC\uFFFD\s*AS/gi, 'ACACÍAS'],
  [/ACAC\uFFFDAS/gi, 'ACACÍAS'],
  [/ITAG\uFFFD\uFFFD?/gi, 'ITAGÜÍ'],
  [/ITAG\uFFFD/gi, 'ITAGÜÍ'],
  [/MEDELL\uFFFDN/gi, 'MEDELLÍN'],
  [/BOGOT\uFFFD/gi, 'BOGOTÁ'],
  [/POPAY\uFFFDN/gi, 'POPAYÁN'],
  [/C\uFFFDCUTA/gi, 'CÚCUTA'],
  [/IBAGU\uFFFD/gi, 'IBAGUÉ'],
  [/MONTER\uFFFD\s*A/gi, 'MONTERÍA'],
  [/MONTER\uFFFDA/gi, 'MONTERÍA'],
];

function fixCityFffd(s) {
  let out = String(s);
  for (const [re, fixed] of CITY_FFFD_FIXES) {
    out = out.replace(re, fixed);
  }
  return out;
}

/** ACU�A → ACUÑA antes de borrar rombos. */
function fixNameFffd(s) {
  return String(s)
    .replace(/([A-ZÁÉÍÓÚÜ])\uFFFD([AEIOUÁÉÍÓÚÜ])/g, '$1Ñ$2')
    .replace(/([a-záéíóúü])\uFFFD([aeiouáéíóúü])/g, '$1ñ$2')
    .replace(/([A-ZÁÉÍÓÚÜ])\uFFFD([Nn])/g, '$1Ñ$2')
    .replace(/([a-záéíóúü])\uFFFD([Nn])/g, '$1ñ$2');
}

export function fixMojibakeText(value) {
  if (value == null) return value;
  let s = String(value);
  if (!s) return s;
  if (/\uFFFD/.test(s)) {
    s = fixCityFffd(s);
    s = fixNameFffd(s);
    s = s.replace(/\uFFFD+/g, '');
    s = s.trim() || String(value).replace(/\uFFFD+/g, '');
  }
  if (!/Ã.|Â.|Ã±|Ã¡|Ã©|Ã­|Ã³|Ãº|Ã¼/i.test(s)) return s;
  try {
    const bytes = Uint8Array.from(s, (ch) => ch.charCodeAt(0) & 0xff);
    const fixed = new TextDecoder('utf-8').decode(bytes);
    if (fixed && !fixed.includes('\uFFFD') && fixed !== s) return fixed;
  } catch {
    /* ignore */
  }
  return s;
}

export function fixClienteDisplay(row) {
  if (!row || typeof row !== 'object') return row;
  const ciudad = fixMojibakeText(row.ciudad);
  const ciudadLimpia =
    ciudad && /^\d[\d\s\-]+$/.test(String(ciudad).trim()) && String(ciudad).replace(/\D/g, '').length >= 7
      ? ''
      : ciudad;
  return {
    ...row,
    nombre: fixMojibakeText(row.nombre),
    display_nombre: fixMojibakeText(row.display_nombre),
    etiqueta: fixMojibakeText(row.etiqueta),
    sede_etiqueta: fixMojibakeText(row.sede_etiqueta),
    padre_nombre: fixMojibakeText(row.padre_nombre),
    ciudad: ciudadLimpia,
    zona: fixMojibakeText(row.zona),
    direccion: fixMojibakeText(row.direccion),
    vendedor_nombre: fixMojibakeText(row.vendedor_nombre),
    cliente_nombre: fixMojibakeText(row.cliente_nombre),
  };
}

/** Etiqueta de entrega cuando el pedido va a una sede del cliente padre. */
export function pedidoClienteLabel(pedido) {
  if (!pedido) return '—';
  const nombre = fixMojibakeText(pedido.cliente_nombre) || '—';
  if (pedido.es_sede || pedido.padre_codigo) {
    const padre = pedido.padre_codigo || '';
    const sede = fixMojibakeText(pedido.sede_etiqueta) || 'Sede';
    return padre ? `${padre} · Sucursal: ${sede}` : `Sucursal: ${sede}`;
  }
  return nombre;
}
